<template>
  <v-container grid-list-xl fluid>
    <div v-if="alerta">
      <alert-empty></alert-empty>
    </div>
    <v-layout justify-center>
      <v-flex>
        <v-toolbar card color="white">
          <v-spacer></v-spacer>
          <template>
            <v-card-actions class="pb-3">
              <v-btn
                v-if="verBoton('EDITAR')"
                :loading="loading"
                color="primary"
                dark
                class="mb-2"
                @click="editAcuerdo()"
                >Aceptar/Rechazar Acuerdo</v-btn
              >
              <v-btn
                v-if="verBoton('NUEVO')"
                :loading="loading"
                color="primary"
                dark
                class="mb-2"
                @click="saveAcuerdoBtn()"
                >Nuevo Acuerdo</v-btn
              >
              <v-btn
                v-if="verBoton('GUARDAR')"
                :loading="loading"
                color="primary"
                dark
                class="mb-2"
                @click="saveChangeAcuerdoBtn()"
                >Guardar Cambios</v-btn
              >
            </v-card-actions>
          </template>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <!-- DIALOGO DE ACEPTAR O RECHAZAR ACUERDO -->
    <template>
      <v-dialog v-model="dialog" persistent max-width="390">
        <v-card>
          <v-card-title class="headline"
            >Aceptar o Rechazar Acuerdo</v-card-title
          >
          <v-card-text>
            <p>
              <b>Seleccione una de las siguientes opciones:</b><br /><br />
              - Si <b>Acepta</b>, se activara el acuerdo previsto.<br />
              - Si <b>Rechaza</b>,se mantendra el ultimo acuerdo vigente.<br /><br />
              <b>Cancele</b> si no se encuentra segura/o.<br /></p
          ></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialog = false"
              >Cancelar</v-btn
            >
            <v-btn color="yellow darken-1" flat @click="rejectAcuerdo"
              >Rechazar</v-btn
            >
            <v-btn color="green darken-1" flat @click="acceptAcuerdoBtn"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <!-- DIALOGO DE ACEPTAR O RECHAZAR ACUERDO -->
  </v-container>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";

export default {
  name: "botones-acuerdo-impresion",
  components: {
    AlertEmpty,
  },
  props: {
    tabSelected: "",
  },
  data() {
    return {
      loading: false,
      proveedor: {},
      rowsTable: [20],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      ultimoAcuerdo: [],
      botonEstado: {},
      usuarioLogged: "",
      dialog: false,
      dialogGrid: false,
      alerta: false,
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
    this.idContrato = this.$store.getters.contratoStored;
    this.loadData();
  },
  created() {},

  methods: {
    verBoton(btn) {
      if (btn == "GUARDAR") {
        if (
          this.botonEstado.idEstado == 5 &&
          this.usuarioLogged.tipo == "PROVEEDOR"
        ) {
          return true;
        } else {
          return false;
        }
      }
      if (btn == "NUEVO") {
        if (
          this.botonEstado.idEstado == 2 &&
          this.usuarioLogged.tipo == "PROVEEDOR"
        ) {
          return true;
        } else {
          return false;
        }
      }
      if (btn == "EDITAR") {
        if (
          this.botonEstado.idEstado == 1 &&
          this.usuarioLogged.tipo == "AGENCIA"
        ) {
          return true;
        } else {
          return false;
        }
      }
    },

    editAcuerdo() {
      this.dialog = true;
      this.loading = true;
    },

    rejectAcuerdo() {
      this.dialog = false;

      let that = this;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        idAcuerdo: this.botonEstado.id,
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
      };

      axios
        .post("/acuerdo/rechazar", this.body)
        .then(function (response) {
          window.getApp.$emit("APP_SAVE");
          return response.data;
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.message);
          console.log(error);
          return [];
        });
    },
    async acceptAcuerdoBtn() {
      this.botonEstado = await this.acceptAcuerdo();
      this.ultimoAcuerdo = [this.botonEstado];
      this.loading = false;
      this.reloadGrid();
    },

    async acceptAcuerdo() {
      this.dialog = false;
      let that = this;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        idAcuerdo: this.botonEstado.id,
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
      };
      return await axios
        .post("/acuerdo/aceptar", this.body)
        .then(function (response) {
          window.getApp.$emit("APP_SAVE");
          return response.data;
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.message);
          console.log(error);
          return [];
        });
    },

    async saveAcuerdoBtn() {
      this.loading = true;
      this.botonEstado = await this.saveAcuerdo();
      this.ultimoAcuerdo = [this.botonEstado];
      this.reloadGrid();
      this.loading = false;
    },
    async saveAcuerdo() {
      let that = this;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        idAcuerdo: this.botonEstado.id,
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
      };
      await axios
        .post("/acuerdo/nuevo", this.body)
        .then(function (response) {
          window.getApp.$emit("APP_CREATE");
          return response.data;
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.message);
          console.log(error);
          return [];
        });
    },
    async saveChangeAcuerdoBtn() {
      this.loading = true;
      this.botonEstado = await this.saveChangeAcuerdo();
      this.ultimoAcuerdo = [this.botonEstado];
      this.reloadGrid();
      this.loading = false;
    },
    async saveChangeAcuerdo() {
      let that = this;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        idAcuerdo: this.botonEstado.id,
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
      };
      await axios
        .post("/acuerdo", this.body)
        .then(function (response) {
          window.getApp.$emit("APP_EDIT");
          return response.data;
        })
        .catch(function (error) {
          if (error.response.code == 404) {
            console.log(error.response.defaultMessage);
          } else {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.message);
            console.log(error);
          }
        });
    },
    async loadUltimoAcuerdo() {
      let that = this;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let conId = this.$store.getters.contratoStored;
      return await axios
        .get("/acuerdo/ultimo/contrato/" + conId + "/" + subProceso)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadData() {
      this.botonEstado = await this.loadUltimoAcuerdo();
      this.loading = false;
      if (
        this.botonEstado.id !== undefined &&
        this.botonEstado.id !== null &&
        this.botonEstado.id !== ""
      ) {
        this.ultimoAcuerdo = [this.botonEstado];
        this.alerta = false;
      } else {
        this.alerta = true;
      }
    },

    reloadGrid() {
      //this.$parent.$parent.bloqueoReloadOn();
      this.$parent.$parent.reloadAcuerdo();
      this.$parent.$parent.reloadDocumento();
      this.$parent.$parent.reloadBoton();
    },
  },
};
</script>
